import { EntityCreateResponse } from '@faro/http-clients';
import { CommandResponse, RevisionedCommandResponse, Schema, toSchema } from '@faro/study-designer-model';
import axios from 'axios';
import { Identifiable } from 'faro-common-model';
import { StudyDesignQueryParameter, StudyPathParameter } from '../parameter';

export type SchemaPathParameters = StudyPathParameter;
export type SchemaQueryParameters = StudyDesignQueryParameter;

/**
 * Client responsible for accessing the backend entity services
 */

export const schemaClient = {
    list: (request?: SchemaPathParameters & SchemaQueryParameters, signal?: AbortSignal): Promise<Schema[]> => {
        const { studyId, ...query } = request ?? {};
        return axios
            .get(`/api/study-designer/studies/${studyId}/schemas`, { params: query, signal })
            .then(response => response.data?.map(toSchema));
    },
    get: (request: SchemaPathParameters & Identifiable, signal?: AbortSignal): Promise<Schema> => {
        const { studyId, id } = request;
        return axios
            .get(`/api/study-designer/studies/${studyId}/schemas/${id}`, { signal })
            .then(response => toSchema(response.data));
    },
    create: (request: SchemaPathParameters & Schema): Promise<EntityCreateResponse> => {
        const { studyId, ...entity } = request;
        return axios.post(`/api/study-designer/studies/${studyId}/schemas`, entity).then(response => response.data);
    },
    update: (request: SchemaPathParameters & Schema): Promise<RevisionedCommandResponse<CommandResponse>> => {
        const { studyId, ...entity } = request;
        return axios
            .put(`/api/study-designer/studies/${studyId}/schemas/${entity.id}`, entity)
            .then(response => response.data);
    },
    delete: (request: SchemaPathParameters & Identifiable): Promise<RevisionedCommandResponse<CommandResponse>> => {
        const { studyId, id } = request;
        return axios.delete(`/api/study-designer/studies/${studyId}/schemas/${id}`).then(response => response.data);
    },
    map: toSchema,
};
